

import { Col, Container, Row, Modal, Button } from 'react-bootstrap';
import MainButton from '../../UI/main-button/MainButton';
import classes from './style/ShoppingCart.module.css';
import { useAppSelector } from '../../hooks/hooks';
import { useNavigate } from 'react-router';
import { colors } from '../../constants/colors';
import { useState, useEffect } from 'react';
import { getUserCurrency } from '../../helpers/getUserCurrency';
import Alert from 'react-bootstrap/Alert';
import { useTranslation } from 'react-i18next';
import ShoppingCartItem from './components/ShopingCartItem';
import strip from "./style/Frame_1597883033[1].png";
import paypal from "./style/Frame_1597883033_(1)[1].png";
import arrow from "./style/arrow.png";
import toast from 'react-hot-toast';
import { setLoading } from '../../store/userSlice';
import axiosInstance from '../../services/http/interceptors/GlobalInterciptor';

const ShoppingCart = () => {
  const { t } = useTranslation();
  const userCountry = getUserCurrency();
  const navigate = useNavigate();
  const cartData = useAppSelector((state) => state.cart);
  const [checkoutIsDisabled, setCheckoutIsDisabled] = useState(false);
  const [showUnavailableModal, setShowUnavailableModal] = useState(false); // State for the modal

  // Check if any item is unavailable
  const checkCartData = () => {
    const hasUnavailableProduct = cartData.data.some((product) => product.is_available !== 1);
    if (hasUnavailableProduct) {
      setCheckoutIsDisabled(true); // Disable checkout if any item is unavailable
    } else {
      setCheckoutIsDisabled(false); // Enable checkout if all items are available
    }
  };

  useEffect(() => {
    checkCartData(); // Run the check whenever cartData changes
  }, [cartData]);

  // Handle payment button click
  const handleCheckout = async (paymentMethod: any) => {
    if (cartData.data.length < 1) {
      toast.error("There are no items in the cart.");
      return;
    }

    // Check for unavailable items
    const hasUnavailableItems = cartData.data.some(
      (product) => product.is_available !== 1
    );

    if (hasUnavailableItems) {
      setShowUnavailableModal(true); // Show the modal if any item is unavailable
      return;
    }

    // Proceed with payment if no unavailable items
    const formData = new FormData();
    formData.append('is_web', '1');
    formData.append('isWallet', '0');
    formData.append('walletAmount', '0');
    formData.append('payment_method', paymentMethod);
    cartData.data.map((item, index) => {
      formData.append(`items[${index}][model_id]`, String(item.model_id));
      formData.append(`items[${index}][model_name]`, item.model_name);
      formData.append(`items[${index}][user_id]`, String(item.user_id));
    });

    try {
      setLoading(true);
      const response = await axiosInstance.post('/api/payment/checkout', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.status === 200) {
        window.location.href = response.data.data;
      } else {
        toast.error("Failed to initiate payment. Please try again.");
      }
    } catch (error) {
      console.error(error);
      toast.error("An error occurred while processing your payment.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Header Section */}
      <div className="text-center position-relative py-5 w-100 ">
        <div className="position-absolute top-0 start-0 w-100 h-100" style={{ backgroundColor: 'rgba(237, 88, 89, 1)' }}></div>
        <div className="position-relative text-white text-center w-100">
          <h1 className="fw-bold mb-2">{t('Shopping Cart')}</h1>
          <span className="text-white d-block">{t('Home - Umrah Camp - Shopping Cart')}</span>
        </div>
      </div>

      {/* Cart Container */}
      <Container fluid className={`d-flex justify-content-center pt-5  ${classes.ShoppingCartContainer}`} style={{ backgroundColor: '#EAFBFC' }}>
        <Row className="w-100" style={{ maxWidth: '800px' }}>
          <h1 className={`p-0 text-center fw-bold ${classes.ShoppingCartTitle}`} style={{ color: 'rgba(237, 88, 89, 1)' }}>
            {t('Shopping Cart')}
          </h1>
          <span className="text-center text-muted mb-4 fs-4">{t('These are the camps you have added to the cart.')}</span>

          {/* Cart Items */}
          <Col md={12} className="d-flex flex-column align-items-center w-100">
            <div className={`w-100 ${classes.CartDetails}`}>
              <div className="Items w-100 col-md-12 ps-0">
                {cartData.data.map((i) => (
                  <ShoppingCartItem key={i.id} data={{ ...i, is_soldout: !!i.is_soldout, is_not_available: !!i.is_not_available }} />
                ))}

                <div className="w-100 d-flex rounded-4 ps-0  p-1 justify-content-between align-items-center ms-1" style={{ backgroundColor: "rgba(250, 210, 26, 1)" }}>
                  <h5 style={{ color: 'rgba(47, 84, 102, 1)', fontWeight: 'bold' }} className='fw-bold p-2'>{t('Total')}:</h5>
                  <h4 style={{ color: 'rgba(47, 84, 102, 1)', fontWeight: '' }} className='p-2 fw-semibold'>
                    ${cartData.totalPrice}
                  </h4>
                </div>

                <Col className={`${classes.CheckoutDetails} d-flex flex-column align-items-center  justify-content-center  w-100`}>
                  <div className="d-flex  justify-content-between   align-items-center w-100">
                    <div className="mt-4 w-100 me-md-2 me-0">
                      <button
                        className='btn py-2 rounded-3 w-100 fw-bold text-white'
                        onClick={() => handleCheckout("paypal")}
                        style={{ backgroundColor: "rgba(19, 178, 188, 1)" }}
                        // disabled={checkoutIsDisabled} // Disable button if checkout is disabled
                      >
                        <img src={paypal} alt="" className='px-3' style={{ width: "60px" }} />
                        Pay with PayPal <img src={arrow} style={{ width: "20px" }} alt="" />
                      </button>
                    </div>
                    <div className="mt-4 w-100">
                      <button
                        className='btn btn-danger rounded-3 py-2 w-100 fw-bold text-white'
                        onClick={() => handleCheckout("stripe")}
                        // disabled={checkoutIsDisabled} // Disable button if checkout is disabled
                      >
                        <img src={strip} alt="" className='px-3' style={{ width: "60px" }} />
                        Pay with Stripe <img src={arrow} style={{ width: "20px" }} alt="" />
                      </button>
                    </div>
                  </div>
                </Col>
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      {/* Unavailable Items Modal */}
      <Modal show={showUnavailableModal} onHide={() => setShowUnavailableModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title className='fw-bold'>Not Avaliable Item On Cart!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Some items Or Number Of Seats in your cart are unavailable. Please remove them to proceed with the payment.</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowUnavailableModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ShoppingCart;